export default "__VITE_ASSET__IZEYwwts__"